import { render, staticRenderFns } from "./TodoApp.vue?vue&type=template&id=00772c8d&scoped=true&"
import script from "./TodoApp.vue?vue&type=script&lang=js&"
export * from "./TodoApp.vue?vue&type=script&lang=js&"
import style0 from "./TodoApp.vue?vue&type=style&index=0&id=00772c8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00772c8d",
  null
  
)

export default component.exports